import React, { useRef, useState } from 'react';
import {
  AiChatButton,
  LeftCol,
  LogoPriceContainer,
  QuotationCardResultStyles,
} from '../components/redesignComponents/ResultPageComponents/v2/SelectedQuoteCard.styles';
import LogoComponentResult from './smallerComponents/LogoComponentResult';
import PriceComponentResult from './smallerComponents/PriceComponentResult';
import QuoteInfoComponentResult from './smallerComponents/QuoteInfoComponentResult';
import CompanyQualityComponent from './smallerComponents/CompanyQualityComponent';
import { Chat } from '../components/chats/MiniChat/MiniChat';
import SparklesIcon from '../../assets/images/icons/SparklesIcon';

function QuotationCardResult({
  processingQuote, requestInfo, profession, set_informativi, extensions, selectableExtensions, docs, guaranteesPrima,
}) {
  const chatRef = useRef();
  const [openChat, setOpenChat] = useState(false);
  const [extraText, setExtraText] = useState('');

  return (
    <QuotationCardResultStyles
      className={processingQuote.is_aquista === 1 ? 'selected' : ''}
    >
      <LeftCol>
        {/* Same "Indice di Qualità" badge as the modal's QuotationCard, missing
            here before this */}
        <CompanyQualityComponent quote={processingQuote} />
        {processingQuote.company_id === 9
          && requestInfo.payment_frequency === 2 && (
            <div className="alert alert-warning mt-1 mb-2 p-1 w-100">
              <b>Attenzione:</b>
              {' '}
              Linear non supporta il pagamento semestrale.
            </div>
        )}
        {processingQuote.company_id === 18
          && requestInfo.payment_frequency === 2 && (
            <div className="alert alert-warning mt-1 mb-2 p-1 w-100">
              <b>Attenzione:</b>
              {' '}
              Genial Piu non supporta il pagamento semestrale.
            </div>
        )}
        {processingQuote.company_id === 2
          && (
            <div className="alert alert-danger mt-1 mb-2 p-1 w-100">
              <small>
                {' '}
                <b>Attenzione:</b>
                {' '}
                Alcuni sconti sonno soggetti a variazioni.
              </small>
            </div>
          )}
        <LogoPriceContainer>
          {/* LOGO Component */}
          <LogoComponentResult quote={processingQuote} />
          {/* Price Component */}
          <PriceComponentResult quote={processingQuote} />
          {/* {!(processingQuote.company_id === 1001 && processingQuote.product_id === 10) && (

          )} */}
          <>
            <AiChatButton onClick={() => setOpenChat(true)}>
              <SparklesIcon width={24} height={24} />
              <span>Chiedi all'AI</span>
            </AiChatButton>
            <Chat
              sub_product={processingQuote?.sub_product}
              ref={chatRef}
              openChat={openChat}
              setOpenChat={setOpenChat}
              company_id={
                processingQuote.company
                  ? processingQuote.company_id
                  : processingQuote.preventivas_company_id
              }
              product_id={processingQuote.product_id}
              quote_type={processingQuote.quote_type}
              company_name={
                processingQuote.company
                  ? processingQuote.company.name
                  : processingQuote.preventivas_company.company_name
              }
              extraText={extraText}
              professionId={profession?.profession}
            />
          </>
        </LogoPriceContainer>
        <QuoteInfoComponentResult
          quote={processingQuote}
          requestInfo={requestInfo}
          profession={profession}
          setExtraText={setExtraText}
          set_informativi={set_informativi}
          extensions={extensions}
          selectableExtensions={selectableExtensions}
          docs={docs}
          guaranteesPrima={guaranteesPrima}
        />
      </LeftCol>
    </QuotationCardResultStyles>
  );
}
export default QuotationCardResult;
